import { HttpParams } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NbDialogService } from "@nebular/theme";
import { NotificationsService } from "angular2-notifications";
import { NgxSpinnerService } from "ngx-spinner";
import { EImportacaoType } from "../../../../shared/importacao-lote/components/table/EImportacaoType";
import { ILoteDetalhes } from "../../../../shared/importacao-lote/dto/ILoteDetalhes";
import cancelarImportacaoLote from "../../../../shared/importacao-lote/utils/cancelar-importacao";
import { FilterService } from "../../../../shared/importacao-lote/utils/filter.service";
import { HttpService } from "../../../../shared/services/http/http-client.service";
import { abrirModalConfirmarCadastro } from "../../../importacao-lote/utils/abrir-modal-confirmar-cadastro";
import { EColumnType } from "../../../importacao-lote/components/table/EColumnType";
import { parseCurrency, roundToCents } from "../../../../shared/importacao-lote/utils/currency-utils";

@Component({
  selector: "ngx-distribuicao-saldo-carga-lote",
  templateUrl: "./distribuicao-saldo.component.html",
  styleUrls: ["./distribuicao-saldo.component.scss"],
})
export class DistribuicaoSaldoComponent implements OnInit {
  public loteId: number = null;
  public loteDetalhes: ILoteDetalhes = {} as ILoteDetalhes;
  public filters: HttpParams = new HttpParams();
  public breadcrumbPath;
  public paymentForm: FormGroup;
  public infoLote = [];
  public fileName: string;
  public valorTotal: number;
  public isDisableContinuar: boolean = true;
  public EImportacaoType = EImportacaoType.FUNCIONARIO;

  constructor(
    private http: HttpService,
    public activatedRoute: ActivatedRoute,
    public formBuilder: FormBuilder,
    public router: Router,
    public spinnerService: NgxSpinnerService,
    public dialogService: NbDialogService,
    public notifications: NotificationsService,
    public filterService: FilterService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe((params: any) => {
      this.loteId = params.params.loteId;
      this.spinnerService.show();
      this.http.doGet(
        `/importacao-funcionario/${params.params.loteId}/detalhes-lote-funcionario`,
        "",
        (response: ILoteDetalhes) => {
          this.loteDetalhes = response;
          this.fileName = response.nomeArquivo;

          // tarifas
          this.http.doGet(
            `/importacao-funcionario/tarifa-emissao-cartao`,
            "",
            (response) => {
              if (response.taxaEmissao) {
                this.loteDetalhes.valorUnidade = response.taxaEmissao;
                this.valorTotal =
                  (this.loteDetalhes.valorUnidade || 0) *
                  (this.loteDetalhes.qtdCartoes || 0);
                this.spinnerService.hide();
              }
            },
            (error) => {
              this.spinnerService.hide();
              this.notifications.error(error.message);
            }
          );
        },
        (error) => {
          this.spinnerService.hide();
          this.notifications.error(error.message);
        }
      );
    });

    this.paymentForm = this.formBuilder.group({
      global: [0, Validators.required],
      currentAccount: [0, Validators.required],
      future: [0, Validators.required],
      total: [0, Validators.required],
    });

    this.paymentForm.valueChanges.subscribe((value) => {
      const expected = roundToCents(this.valorTotal || 0);
      const total = roundToCents(parseCurrency(value.total));
      if (
        expected === total &&
        total > 0
      ) {
        this.isDisableContinuar = false;
      } else {
        this.isDisableContinuar = true;
      }
    });

    this.breadcrumbPath = [
      { label: `Lote ID ${this.loteId}` },
      {
        label: "Importação",
        link: `/pages/gestao-funcionarios/importar-arquivo?loteId=${this.loteId}`,
      },
      {
        label: "Revisar",
        link: `/pages/gestao-funcionarios/validar-importacao?loteId=${this.loteId}`,
      },
      {
        label: "Cartão",
        link: `/pages/gestao-funcionarios/validar-pagamento-cartao?loteId=${this.loteId}`,
      },
      { label: "Pagamento" },
    ];

    this.getDados();
  }

  setInfoLote() {
    this.infoLote = [
      {
        title: "Nome do arquivo",
        value: this.loteDetalhes.nomeArquivo,
        type: EColumnType.STRING,
      },
      {
        title: "Data de criação",
        value: this.loteDetalhes.dataCadastro,
        type: EColumnType.DATE,
      },
      {
        title: "Erros cadastro",
        value: this.loteDetalhes.qtdErros,
        type: EColumnType.NUMBER,
      },
      {
        title: "Total cadastrado",
        value:
          (this.loteDetalhes.qtdImportada || 0) -
          (this.loteDetalhes.qtdErros || 0),
        type: EColumnType.NUMBER,
      },
      {
        title: "Tipo",
        value: this.loteDetalhes.tipo,
        type: EColumnType.STRING,
      },
      {
        title: "Quantidade de cartões",
        value: this.loteDetalhes.qtdCartoes,
        type: EColumnType.NUMBER,
      },
      {
        title: "Valor da unidade",
        value: this.loteDetalhes.valorUnidade || 0,
        type: EColumnType.CURRENCY,
      },
      {
        title: "Total do pedido cartões",
        value:
          (this.loteDetalhes.valorUnidade || 0) *
          (this.loteDetalhes.qtdCartoes || 0),
        type: EColumnType.CURRENCY,
      },
    ];
  }

  getDados() {
    this.http.doGet(
      `/importacao-funcionario/${this.loteId}/detalhes-lote-funcionario`,
      "",
      (response: ILoteDetalhes) => {
        this.loteDetalhes = response;
        if (this.loteDetalhes.tipo.toLowerCase() === "nominal") {
          // tarifas
          this.http.doGet(
            `/importacao-funcionario/tarifa-emissao-cartao`,
            "",
            (response) => {
              if (response.taxaEmissao) {
                this.loteDetalhes.valorUnidade = response.taxaEmissao;
              }

              this.setInfoLote();
            }
          );
        } else {
          this.setInfoLote();
        }
      }
    );
  }

  openConfirmModal() {
    const form = this.paymentForm.getRawValue();
    const valorSaldoGlobal = roundToCents(parseCurrency(form.global));
    const valorSaldoConta = roundToCents(parseCurrency(form.currentAccount));
    const valorSaldoRecebiveis = roundToCents(parseCurrency(form.future));

    abrirModalConfirmarCadastro(
      this.dialogService,
      {
        emitirCartao: "SIM",
        loteDetalhes: this.loteDetalhes,
        textButtonConfirm: "CONFIRMAR",
      },
      () => {
        this.spinnerService.show();
        this.http.doPost(
          `/importacao-funcionario/${this.loteId}/processar-pagamento`,
          {
            valorSaldoGlobal: valorSaldoGlobal,
            valorSaldoConta: valorSaldoConta,
            valorSaldoRecebiveis: valorSaldoRecebiveis,
            valorPrimeiraVia: Number(this.loteDetalhes.valorUnidade || 0),
          },
          (_response: any) => {
            this.spinnerService.hide();
            this.notifications.success("Lote processado com sucesso!");
            this.navigate();
          },
          (_error: any) => {
            this.spinnerService.hide();
            this.notifications.error(_error.message ||  "Erro ao processar dados!");
          }
        );
      },
      (_error) => {
        this.spinnerService.hide();
      }
    );
  }

  navigate() {
    this.router.navigate(["/pages/gestao-funcionarios/importacao-finalizada"], {
      relativeTo: this.activatedRoute,
      queryParams: { loteId: this.loteId },
    });
  }

  onContinue() {
    const expected = roundToCents(this.valorTotal || 0);
    const total = roundToCents(
      parseCurrency(this.paymentForm.get("total").value)
    );
    if (
      total === expected &&
      expected > 0
    ) {
      this.openConfirmModal();
    }
  }

  onCancel() {
    cancelarImportacaoLote(
      this.dialogService,
      this.spinnerService,
      this.notifications,
      this.router,
      this.http,
      this.loteDetalhes,
      this.EImportacaoType
    );
  }

}
